import React, { useState, useEffect, useMemo } from "react";

// ANT DESIGN
import {
  Input,
  Row,
  Card,
  Table,
  Spin,
  Button,
  Space,
  Form,
  Dropdown,
  Pagination,
  Select,
} from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/layouts/enhancement/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../treasury.config";
import { Util } from "./helper/helper";
import SearchLg from "@untitled-ui/icons-react/build/esm/SearchLg";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import ArrowLeft from "@untitled-ui/icons-react/build/esm/ArrowLeft";
import ArrowRight from "@untitled-ui/icons-react/build/esm/ArrowRight";

//global distructures

const ManageTreasuryBill = (props) => {
  //DECLARED VARIABLES
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState("10");
  const [statusPopisOpen, setStatusPopisOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [statusFilter, setStatusFilter] = useState("Active");
  // const [searchKey, setSearchKey] = useState("");
  // const [selectedStatus, setSelectedStatus] = useState("Status");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [data, setData] = React.useState([]);
  const [treasuryBillList, setTreasuryBillList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [loading, setLoading] = useState(false);
  const pageSize = 10;

  // TO FILTER
  // React.useEffect(() => {
  //   console.log(statusFilter, "statusFilter");
  //   const filteredTemp = treasuryBillList.filter((item) =>
  //     item?.productName?.toLowerCase().includes(searchterm.toLowerCase())
  //   );

  //   if (statusFilter === "Status") {
  //     setData(filteredTemp);
  //   } else {
  //     const temp = filteredTemp.filter(
  //       (item) =>
  //         item?.status?.text?.toLowerCase() ===
  //         String(statusFilter)?.toLowerCase()
  //     );
  //     setData(temp);
  //   }
  //   console.log(data);
  // }, [statusFilter, treasuryBillList, searchterm]);

  const filteredData = useMemo(() => {
    if (!statusFilter || statusFilter === "Status") {
      return originalList;
    }

    return originalList.filter(
      (item) =>
        item?.status?.text?.toLowerCase() ===
        String(statusFilter)?.toLowerCase()
    );
  }, [statusFilter, originalList]);

  const treasuryBillData = useMemo(() => {
    const filtered = filteredData.filter((item) =>
      item?.productName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const start = (currentPage - 1) * pageSize;
    const end = currentPage * pageSize;
    return filtered.slice(start, end);
  }, [filteredData, searchTerm, currentPage]);

  const totalPages = Math.ceil(filteredData.length / pageSize);

  // TO SEARCH
  // React.useEffect(() => {
  //   const temp = data.filter((item) =>
  //     item?.productName?.toLowerCase().includes(searchterm.toLowerCase())
  //   );
  //   if (searchterm) {
  //     setData(temp);
  //   } else {
  //     setData(data);
  //   }
  // }, [searchterm]);

  const columns = [
    {
      title: (column) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {labelConfig.productName}
          <div>
            <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
          </div>
        </div>
      ),

      dataIndex: "productName",
      sorter: (a, b) =>
        String(a.productName).localeCompare(String(b.productName)),
    },
    {
      title: labelConfig.instrument,
      dataIndex: "instrument",
    },
    {
      title: labelConfig.currency,
      dataIndex: "currency",
    },
    {
      title: labelConfig.tenorSupported,
      dataIndex: "tenor",
    },
    {
      title: labelConfig.issuer,
      dataIndex: "issuer",
    },
    {
      title: labelConfig.status,
      dataIndex: "status",
      render: (_, record) => {
        return staticConfig.renderStatus(record.status.text);
      },
    },
  ];

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-treasury-bill", { state: selectedRow });
    } else {
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-treasury-bill", { state: selectedRow });
    } else {
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-treasury-bill", { state: selectedRow });
    } else {
    }
  }

  function handleFilterByStatus(newStatus) {
    setStatusFilter(newStatus);
  }

  function onSearch() {}

  function handleSearchInTable(e) {
    setSearchTerm(e.target.value);
  }

  const onSelectItemAction = (objParam, selectedRow) => {
    // If no row or multiple rows selected, reset read and update
    if (objParam.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      // Re-activate other buttons that should remain (like addBtn)
      BOM.HasPermission("CREATE_TREASURY_BILL_PRODUCT") &&
        dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    // Only one row is selected
    setSelectedRow(selectedRow[0]);

    if (BOM.HasPermission("READ_TREASURY_BILL_PRODUCT")) {
      dispatch({ type: cnt.RIGHT_DETAIL_BTN });
    }
    if (
      selectedRow[0]?.status?.text?.toLowerCase() === "pending" &&
      BOM.HasPermission("UPDATE_TREASURY_BILL_PRODUCT")
    ) {
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
    }
  };

  const getTreasuryBillListAction = () => {
    // START LOAD
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      apiConfig.TreasuryBillProducts,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              productName: element?.productName || "-",
              counterpartyType: element?.counterpartyType || "-",
              currency: element?.currencyCode || "-",
              status: element?.status || "-",
              instrument: element?.productType?.text || "--",
              tenor: element?.tenor?.text || "--",
              issuer: element?.issuer?.name || "--",
            });
          });

          setTreasuryBillList(tempArray);
          setOriginalList(tempArray);

          //STOP LOAD
          setLoading(false);
        }
      },
      "treasury"
    );
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        // params,
      };

      BOM.FetchReqAction(body, apiConfig.TreasuryBillProducts, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              productName: element?.productName || "-",
              counterpartyType: element?.counterpartyType || "-",
              currency: element?.currencyCode || "-",
              status: element?.status?.text || "-",
              instrument: element?.productType?.text || "--",
              tenor: element?.tenor?.text || "--",
              issuer: element?.issuer?.name || "--",
            });
          });

          resolve(tempArray);
        }
      });
    }, "treasury");
  };

  useEffect(() => {
    BOM.HasPermission("READ_TREASURY_BILL_PRODUCT") &&
      getTreasuryBillListAction();
    BOM.HasPermission("CREATE_TREASURY_BILL_PRODUCT") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
  // setBondsList(tempArray.filter((item) => item.disabled === false));

  //keep the orginal data to use after gList is modified when change from autorise to disable
  // setOriginalList(tempArray);

  // React.useEffect(() => {
  //   setStatusFilter("Active");
  // }, []);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      pageItems={staticConfig.manageBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.treasuryBill}
        createPageTitle={"Product Listing"}
      />

      <Card
        style={{
          border: "1px solid #EAECF0",
          borderRadius: 20,
          padding: 0,
          marginTop: 12,
        }}
      >
        <Spin spinning={loading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <Row style={{}}>
              <Row style={{}}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    direction="horizontal"
                    style={{
                      width: "100%",
                    }}
                  >
                    <Form.Item style={{ margin: 0 }} name="searchKey">
                      <Input
                        value={searchTerm}
                        onChange={handleSearchInTable}
                        placeholder="Search by Name"
                        prefix={<SearchLg width={18} color="#667085" />}
                        style={{
                          width: 400,
                          borderRadius: "10px",
                        }}
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form>
                <Space
                  style={{
                    marginLeft: 10,
                    alignSelf: "center",
                  }}
                  direction="vertical"
                >
                  <Select
                    defaultValue="Active"
                    options={staticConfig.statusLabels}
                    onSelect={handleFilterByStatus}
                    bordered={false}
                    style={{
                      backgroundColor: "#F9FAFB",
                      border: "1px solid #EAECF0",
                      // backgroundColor: "transparent",
                      borderRadius: 50,
                      height: 30,

                      // minWidth: 120,
                    }}
                    dropdownStyle={{
                      borderRadius: 8,
                      width: "250px",
                    }}
                  />
                  {/* <Dropdown
                    open={statusPopisOpen}
                    onOpenChange={(e) => setStatusPopisOpen(e)}
                    menu={{
                      multiple: false,
                      selectable: true,
                      items,
                      seperator: true,
                    }}
                    placement="bottomLeft"
                  >
                    <Button
                      color="#F9FAFB"
                      icon={<ChevronDown width={18} color="#667085" />}
                      size={"middle"}
                      iconPosition="end"
                      shape="round"
                      style={{
                        backgroundColor: "#F9FAFB",
                        borderColor: "#EAECF0",
                      }}
                    >
                      {statusFilter ? Util.capitalizeFirstLetter(statusFilter?.label) : "Status"}
                    </Button>
                  </Dropdown> */}
                </Space>
              </Row>
            </Row>
            {/* <DownloadTableButtons
              downloadData={treasuryBillList}
              columns={columns}
              fileName={"Treasury Bill List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>

          <div className="treasury-bills-table-container">
            <Table
              className="bond-table"
              rowSelection={{
                type: "checkbox",
                onChange: onSelectItemAction,
                hideSelectAll: true,
              }}
              columns={columns}
              dataSource={treasuryBillData}
              pagination={false}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            {/* {true == false ? (
              <Button disabled>
                <ArrowLeftOutlined /> Previous
              </Button>
            ) : (
              <div style={{ width: 100 }} />
            )} */}
            <Button
              style={{
                backgroundColor: "white",
                borderRadius: 8,
                border: "1px solid #D0D5DD",
                padding: "8px 12px",
                fontSize: "14px",
                fontWeight: "600",
              }}
              className="previous-button"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <ArrowLeft style={{ width: "20px", height: "20px" }} /> Previous
            </Button>

            <Pagination
              current={currentPage}
              total={filteredData.length}
              pageSize={pageSize}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
              itemRender={itemRender}
              align="center"
            />

            {/* <Button disabled>
              Next <ArrowRightOutlined />
            </Button> */}
            <Button
              style={{
                backgroundColor: "white",
                borderRadius: 8,
                border: "1px solid #D0D5DD",
                padding: "8px 12px",
                fontSize: "14px",
                fontWeight: "600",
              }}
              className="previous-button"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage >= totalPages}
            >
              Next <ArrowRight style={{ width: "20px", height: "20px" }} />
            </Button>
          </div>
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageTreasuryBill);
